var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDerevaLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_1",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 363.3 76.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: #ffffff;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.1,39.1c20.4,2.1,29.7,2.3,49.2-1.8s0,18.9,0,18.9c-22.9-1.9-34.4-7.1-49.2-17.1h0Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "55.4 27.8 74.2 46.6 55.4 65.4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.2,65.4V10.2h17.2c7.8,0,13.9,1,18.3,3s7.8,5.1,10.3,9.2c2.5,4.2,3.8,9.3,3.8,15.4s-1.3,10.5-3.9,14.9-6.1,7.6-10.5,9.6c-4.4,2-10.3,3-17.8,3h-17.4ZM101.3,18.9v37.8h5.9c12.7,0,19-6.3,19-19s-6.3-18.9-19-18.9h-5.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M185.9,45.9h-30.1c.5,8.5,5.3,12.7,14.5,12.7s9.6-1.7,14.4-5.2h.4v9.7c-5.7,2.2-11.1,3.3-16.2,3.3-8,0-14-1.9-18.2-5.7-4.2-3.8-6.3-9.2-6.3-16.4s2-12.7,5.9-16.7c4-4.1,9.4-6.1,16.4-6.1,12.7,0,19.1,6.8,19.1,20.3v4ZM174.6,39.6c0-7.3-3.1-11-8.9-11s-9.5,3.7-9.9,11h18.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M222.9,34.4h-.4c-1.5-.4-3.5-.6-6.1-.6-4,0-7.6.6-11,1.9v29.6h-11.2V23h11.2v7.7c3.4-3.1,6.3-5.2,8.5-6.2,2.2-1.1,4.4-1.6,6.6-1.6s1.4,0,2.4,0v11.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M267.6,45.9h-30.1c.5,8.5,5.3,12.7,14.5,12.7s9.6-1.7,14.4-5.2h.4v9.7c-5.7,2.2-11.1,3.3-16.2,3.3-8,0-14-1.9-18.2-5.7-4.2-3.8-6.3-9.2-6.3-16.4s2-12.7,5.9-16.7c4-4.1,9.4-6.1,16.4-6.1,12.7,0,19.1,6.8,19.1,20.3v4ZM256.4,39.6c0-7.3-3.1-11-8.9-11s-9.5,3.7-9.9,11h18.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M315.6,23l-17.4,42.4h-10.6l-17.3-42.4h12.2l10.8,29.4,10.7-29.4h11.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M356.2,65.4h-11.2v-5.5c-3.4,3-6.2,4.8-8.4,5.5s-4.4,1.1-6.8,1.1c-3.7,0-6.8-1.2-9.2-3.6-2.4-2.4-3.7-5.5-3.7-9.3s1.8-8.4,5.4-10.9c3.6-2.5,11.2-4,22.8-4.6v-1.1c0-2.7-.9-4.6-2.7-5.8-1.8-1.2-4.9-1.8-9.1-1.8s-7,1.1-12.4,3.3h-.4v-8.9c5.7-1.4,10.8-2,15.4-2,7.2,0,12.3,1.2,15.5,3.5s4.8,6,4.8,11v29.2ZM345,55.1v-10.7c-7.4.6-12,1.6-13.8,2.8-1.9,1.3-2.8,3.1-2.8,5.3s.6,4.1,1.9,5.1,3.3,1.4,6.1,1.4,5.8-1.3,8.6-4Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDerevaLogoWhite);
export default __webpack_public_path__ + "static/media/Dereva_logo_white.2da78c70be9030422c392a34d3479822.svg";
export { ForwardRef as ReactComponent };